import { Category } from 'src/common/types/api/listings';
import extractTextFromHTML from 'src/common/utils/extractTextFromHTML';
import {
  DESCRIPTION_MAX_LENGTH,
  HEADLINE_MAX_LENGTH,
  HEADLINE_MIN_LENGTH,
} from 'src/admin/listing-editor/constants';

export const validateHeadline = (headline: string): boolean => (
  !!(headline
    && headline?.trim().length >= HEADLINE_MIN_LENGTH
    && headline?.trim().length <= HEADLINE_MAX_LENGTH)
);

export const validateShortname = (shortname: string): boolean => (
  !!(shortname?.trim()?.length > 0)
);

export const getDescriptionText = (description: string): string => (
  extractTextFromHTML(description).trim()
);

export const validateDescription = (description: string): boolean => {
  if (!description) return false;
  const pureDescription = getDescriptionText(description);
  return !!(pureDescription && pureDescription.length <= DESCRIPTION_MAX_LENGTH);
};

// TODO: remove this with `listing-tagging--migrate-capacity-field` removal
export const validateCapacity = (capacity: number): boolean => (
  capacity > 0 && capacity <= 1000
);

type PrimaryCategoryValidation = {
  categories: Category[];
  categoryCount: number;
  primaryCategory: Category;
};
export const validatePrimaryCategory = ({
  categories,
  categoryCount,
  primaryCategory,
}: Partial<PrimaryCategoryValidation>): boolean => (
  !!(
    (categoryCount ?? 0) > 0
    || primaryCategory?.primary
    || categories?.some((category) => category.primary)
  )
);
